<!--
  SupportStars.svelte — a satisfaction rating shown as five small stars.

  Display only: the rating input lives in `SupportRating`, which uses this for
  its read-only face. Filled stars are amber, the rest grey; an unrated ticket
  shows a muted dash rather than five empty stars, which would read as a
  rating of zero. The row is one image to assistive technology, named
  "Rated N out of 5", so a screen reader does not count stars aloud.
-->
<script lang="ts">
	import { t } from '../i18n';

	interface Props {
		/** The rating, 1–5, or `null` while unrated. */
		rating: number | null | undefined;
		/** Star size: `sm` for table cells, `md` for cards. */
		size?: 'sm' | 'md';
		/** Extra classes on the row. */
		class?: string;
	}

	let { rating, size = 'sm', class: className = '' }: Props = $props();
</script>

{#if rating === null || rating === undefined}
	<span class="text-xs text-gray-400 dark:text-gray-500 {className}" aria-label={$t('Not rated')}>—</span>
{:else}
	<span
		class="inline-flex items-center gap-0.5 whitespace-nowrap {size === 'sm' ? 'text-[10px]' : 'text-sm'} {className}"
		role="img"
		aria-label={$t('Rated {{rating}} out of 5', { rating })}
	>
		{#each [1, 2, 3, 4, 5] as star (star)}
			<i
				class="fa-solid fa-star {star <= rating ? 'text-amber-400' : 'text-gray-300 dark:text-gray-600'}"
				data-filled={star <= rating}
			></i>
		{/each}
	</span>
{/if}
